import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./DanceStyles.module.scss";
import Aos from "aos";
import "aos/dist/aos.css";
import vid from "../../videos/rumba.mp4";
import bachata from "../../videos/bachata4.mp4"
import drustveni from "../../videos/bachata3.mp4";
import tango from "../../videos/tango.mp4";
import moderan from "../../videos/moderan.mov"

const stylesData = [
  { id: "latino", category: "Latino-američki plesovi", description: "Samba, Ča-ča-ča, Rumba...", vid: `${vid}` },
  { id: "standard", category: "Standardni plesovi", description: "Valcer, Tango, Slowfox...", vid: `${tango}` },
  { id: "caribbean", category: "Karipski društveni plesovi", description: "Salsa, Bachata, Kizomba...", vid: `${bachata}` },
  { id: "social", category: "Društveni plesovi", description: "Swing, Rock’n’Roll, Foxtrot...", vid: `${drustveni}` },
];

const DanceStyles = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <section className={styles.danceStyles} id="izbor" role="region" aria-label="Izbor plesa"> {/* Dodajemo role i aria-label */}
      <h2 data-aos={"fade-up"}>Koji ples biraš?</h2>
      <div className={styles.grid}>
        {stylesData.map((item) => (
          <Link to={`/style/${item.id}`} key={item.id} className={styles.card} data-aos={"fade-up"}>
            <div className={styles.videoContainer}>
              <video autoPlay loop muted playsInline preload="none" aria-label="Pozadinski video" className={styles.videoBg}>
                <source src={item.vid} type="video/mp4"/>
              </video>
              <div className={styles.overlay}></div>
            </div>
            <div className={styles.textContainer}>
              <h3>{item.category}</h3>
              <p>{item.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default DanceStyles;